import type {InviteUserManagementUserFormPayload} from "./invite-user-management-user.schema";
import {inviteUserManagementUserMapper} from "./invite-user-management-user.mapper";
import {inviteUserManagementUser} from "@project/sdk/user-management";
import {
  InviteUserManagementUserHeader,
  InviteUserManagementUserResponse,
} from "@project/sdk/user-management/zod";
import {mutationOptions} from "@tanstack/react-query";
import {
  userManagementUserKeys,
  userManagementUserMutationKeys,
} from "../../../userManagementUser-keys";

export function inviteUserManagementUserMutationOptions() {
  return mutationOptions({
    mutationKey: userManagementUserMutationKeys.inviteUserManagementUser,
    mutationFn: async (payload: InviteUserManagementUserFormPayload) =>
      InviteUserManagementUserResponse.parse(
        await inviteUserManagementUser(inviteUserManagementUserMapper.toSdk(payload), {
          headers: InviteUserManagementUserHeader.parse({
            "Idempotency-Key": payload.idempotencyKey,
          }),
        }),
      ),
    onSuccess: async (_data, _variables, _context, {client}) => {
      await client.invalidateQueries({queryKey: userManagementUserKeys.lists()});
    },
  });
}
